<style scoped>
.upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    width: 100%;
}
.upload-btn-wrapper input[type=file] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
}
</style>
<script>
import { notify } from '@/helpers/notify' 
import Loader from "@/components/widgets/loader.vue";

export default {
    name: 'Transaction',
    props:[
        "transactionData"
    ],
    components: {
        Loader
    },
    data() {
        return {
            submitted: false,
            cableUse:"0",
            form: {
                coordinate: '',
            },
            selectedFiles: {},
            uploaded:[],
            sendable: false,
            ertele: false,
            loading:false,
            dataCheck:{}
        };
    },
    computed:{ 
        ModalTitle(){
            return `İşleme Al `
        },
        KonumLabel(){
            return this.form.coordinate ? 'Tekrar Konum Al' : 'Konum Al'
        },
    },
    watch:{
        transactionData(props){
           
            this.form = {}
            this.cableUse = "0"
            this.uploaded= []
            this.selectedFiles = {}
            this.sendable = false
            this.ertele = false
            if(props.type_id == 2){
                this.sendable = true
            }    

            const uuid = props.subs_id;

            if(props.type_id != 4 && props.type_id != 2){
                this.$http.get(`/members/${uuid}/imageAndCoordinate`)
                .then(response =>{
                    this.dataCheck = {
                        coordinate: !!response.data.coordinate,
                    }    
                    response.data?.images.forEach(el => {
                    this.dataCheck[el.name] = !!el.name
                    });
                    this.kontrol()
                })
            } 
            this.form = Object.assign( {...props}, this.form)
        }
    },
    methods: {
        imageRemove(key){
            //const updatedFileList = Array.from(this.selectedFiles);
            //updatedFileList.splice(idx, 1);
            this.selectedFiles = delete  this.selectedFiles[key]; 
            this.kontrol()
        },
        async uploadImage(event, name){
            const file = event.target.files[0];
            const resizedBlob = await this.resizeImage(file, 800); 
            this.uploaded.push(name);
            this.selectedFiles[name] = resizedBlob;
            this.kontrol()
        },
        async resizeImage(file, maxWidth) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (readerEvent) => {
                const image = new Image();
                image.onload = () => {
                    const { width, height } = this.calculateAspectRatioFit(image.width, image.height, maxWidth);
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                    canvas.toBlob((blob) => {
                    resolve(blob);
                    }, file.type);
                };
                image.src = readerEvent.target.result;
                };
                reader.readAsDataURL(file);
            });
            },
        calculateAspectRatioFit(srcWidth, srcHeight, maxWidth) {
            const ratio = maxWidth / srcWidth;
            return { width: maxWidth, height: srcHeight * ratio };
        },
         async uploadBlobToServer(blob) {
            const formData = new FormData();
            formData.append('image', blob, 'resized_image.jpg'); 
        },
        kontrol(){
            if(
                (this.form.coordinate ||
                this.dataCheck.coordinate) &&
                (this.selectedFiles['kurulum'] ||
                this.dataCheck.kurulum) && 
                (this.selectedFiles['adaptor'] ||
                this.dataCheck.adaptor) && 
                (this.selectedFiles['anten'] ||
                this.dataCheck.anten) && 
                (this.selectedFiles['kapi'] ||
                this.dataCheck.kapi)
            ){
                this.sendable = true
            }else{
                this.sendable = false
            }
        },
        async imageRead(file){
                return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            // Resmi Blob verisine dönüştürün
                            const resimBlob = e.target.result;
                            resolve(resimBlob);
                        };
                        reader.onerror = (hata) => {
                            reject(hata);
                        };
                        reader.readAsDataURL(file);
                    });
        },
        async getCoordinate(){
            const coordinate = await this.getBrowseCoordinate()
            
            if(coordinate.error){
                if(coordinate.message == "User denied Geolocation"){
                    notify.error('Tarayıcıdan erişime izin vermeniz gerekmektedir.','center-center',false)
                }
            }else{
                this.form = { 
                    ...this.form, 
                    coordinate:coordinate.content.latitude +', '+ coordinate.content.longitude
                } 
            }
          
            this.kontrol()
        },
        async getBrowseCoordinate(){
            let konum;

            if ("geolocation" in navigator) {
                try {
                    const position = await new Promise((resolve, reject) => {
                        navigator.geolocation.getCurrentPosition(resolve, reject);
                    });

                    konum = {
                        error:false,
                        content:{
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        }
                    };

                } catch (hata) {
                    // Hatanın türüne göre işlem yapabilirsiniz
                    // eslint-disable-next-line no-undef
                    if (hata instanceof GeolocationPositionError) {

                        konum = {
                            error:true,
                            message: hata.message,
                            content:{}
                        };
                    } else {
                        konum = {
                            error:true,
                            message: hata.message,
                            content:{}
                        };
                    }
                }
            } else {
                // eslint-disable-next-line no-console
                alert("Tarayıcınız konum hizmetini desteklemiyor.");
            }

            return konum;
        },
        close(){
            this.$parent.$bvModal.hide('transaction')
        },
        async handleSubmit(){
            this.loading = true
            const formData = new FormData();
            for (let [key, val] of Object.entries(this.form)) {
                formData.append(key, val);
            }
            if(this.ertele){
                formData.append('ertele', 1);
            }
            else{   
                for (const [key, value] of Object.entries(this.selectedFiles)){
                    formData.append(`images[${key}]`, value, 'resim.jpeg');
                }
            }

            const response = await this.$http.post('members/process', formData, {headers: { 'Content-Type': 'multipart/form-data' }});
            if (response.status === 200) {
                if(response.data.error){
                    this.loading = false
                    return notify.error(response.data.message)
                }
                this.$emit('loadItems')
                this.close()
                this.loading = false
                return notify.success(response.data.message)
            } else {
                this.loading = false
                return notify.error(response.data.message)
            }
        },
        postpone(data)
        {
            this.ertele = data == 1 ? true : false
        }
    },
};
</script>

<template>
<b-modal id="transaction" :title="ModalTitle"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit" enctype="multipart/form-data">
        <Loader :loading="true" :load="loading">
        <div v-if="!ertele">
            <div class="row" v-if="form.type_id != '2'">
                <div class="col-md-12">
                    <table class="table table-borderless" style="border:dashed 1px;border-radius:10px">
                        <tbody>
                            <tr>
                                <td style="width: 140px;">
                                    <p class="mb-0">Kullanıcı Adı:</p></td>
                                    <td style="width: 120px;"><h5 class="mb-0"> {{ form.username }}</h5>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 140px;">
                                    <p class="mb-0">PPOE Şifre:</p></td>
                                    <td style="width: 120px;"><h5 class="mb-0"> {{ form.password }}</h5>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row d-flex flex-wrap mb-2" v-if="form.type_id != '2' && !dataCheck.coordinate">
                <div class="col">
                    <button 
                        type="button" 
                        class="btn btn-lg" 
                        :class="[this.form.coordinate ? 'btn-success' : 'btn-light' ,'']" 
                        style="width:100%" 
                        @click="getCoordinate()">
                        {{ KonumLabel }}
                    </button>
                </div>
            </div>
            <div class="row d-flex flex-wrap" v-if="form.type_id != '2'">
                <div class="col-md-6" v-if="!dataCheck.kurulum">
                    <div class="upload-btn-wrapper">
                        <button type="button"  v-if="uploaded.includes('kurulum')" for="upload" style="width:100%; display: inline-block;" class="btn btn-success btn-lg">Anten Kurulum Resmi Tekrar Yükle</button>
                        <button type="button"  v-else for="upload" style="width:100%; display: inline-block;" class="btn btn-light  btn-lg">Anten Kurulum Resmi Yükle</button>
                        <input type="file" @change="uploadImage($event, 'kurulum')"  name="images[]" accept="image/*" />
                    </div>
                </div>
                <div class="col-md-6" v-if="!dataCheck.anten">
                    <div class="upload-btn-wrapper">
                         <button type="button"  v-if="uploaded.includes('anten')" for="upload" style="width:100%; display: inline-block;" class="btn btn-success btn-lg">Anten Uzaktan Resim Tekrar Yükle</button>
                        <button type="button" v-else for="upload" style="width:100%; display: inline-block;" class="btn btn-light  btn-lg">Anten Uzaktan Resim Yükle</button>
                        <input type="file" @change="uploadImage($event, 'anten')"  name="images[]" accept="image/*" />
                    </div>
                </div>
            </div>
            <div class="row d-flex flex-wrap" v-if="form.type_id != '2'">
                <div class="col-md-6" v-if="!dataCheck.kapi">
                    <div class="upload-btn-wrapper">
                        <button type="button"  v-if="uploaded.includes('kapi')" for="upload" style="width:100%; display: inline-block;" class="btn btn-success btn-lg">Dış Kapı Resim Tekrar Yükle</button>
                        <button type="button" v-else for="upload" style="width:100%; display: inline-block;" class="btn btn-light  btn-lg">Dış Kapı Resim <br> Yükle</button>
                        <input type="file" @change="uploadImage($event, 'kapi')"  name="images[]" accept="image/*"/>
                    </div>
                </div>
                <div class="col-md-6" v-if="!dataCheck.adaptor">
                    <div class="upload-btn-wrapper">
                           <button type="button"  v-if="uploaded.includes('adaptor')" for="upload" style="width:100%; display: inline-block;" class="btn btn-success btn-lg">Adaptör Resmi Tekrar Yükle</button>
                        <button type="button" v-else for="upload" style="width:100%; display: inline-block;" class="btn btn-light  btn-lg">Adaptör Resmi <br> Yükle</button>
                        <input type="file" @change="uploadImage($event, 'adaptor')"  name="images[]" accept="image/*"/>
                    </div>
                </div> 
            </div>
            
            <div class="row mb-1" v-if="form.type_id == '2' || form.type_id == '1'">
               <div class="col-12 mb-1">    
                    <h6 class="mb-2" v-if="form.type_id == '1'">Sökülen Cihaz/Malzemeler</h6>
                    <h6 class="mb-2" v-else>Takılan Cihaz/Malzemeler</h6>
                    <div class="row">
                        <div class="col-12 mb-1">
                            <div class="form-check form-check-success">
                                <input class="form-check-input" type="checkbox" id="poe" value="1" v-model="form.poe">
                                <label class="form-check-label" for="poe"> Poe </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-1">
                            <div class="form-check form-check-success">
                                <input class="form-check-input" type="checkbox" id="adaptor" value="1" v-model="form.adaptor">
                                <label class="form-check-label" for="adaptor"> Adaptör </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row d-flex flex-wrap mb-1" v-if="form.type_id == '2' && form.mac">
                <div class="col-12 mb-1">
                    M.A.C adresi : <span class="badge rounded-pill bg-light text-dark" style="font-size:16px"> {{ form.mac }}</span>
                </div>
            </div>
        </div>
        <div v-if="ertele">
            <div class="row d-flex flex-wrap mb-3">
                <div class="col-xl-12">
                    <div class="mb-3">
                        <label for="desc">Erteleme Nedeni</label>
                        <textarea id="desc" type="text" class="form-control" v-model="form.description" ></textarea>
                    </div>
                </div>
            </div>     
        </div>
        <hr>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="postpone('2')" v-if="ertele">Geri Dön</b-button>
            <b-button variant="light" @click="close()"  v-if="!ertele">Vazgeç</b-button>
            <b-button variant="warning" @click="postpone('1')" v-if="!ertele">Ertele</b-button>
            <b-button variant="success" type="submit"  v-if="ertele">Kaydet</b-button>
            <b-button 
                v-if="!ertele"
                :disabled="!sendable"
                type="submit" 
                variant="success" 
                class="ms-1"
                >Tamamla
            </b-button>
        </div>
        </Loader>
    </form>
</b-modal>
</template>
